import useLocation from 'lib/hooks/useLocation';

import { Icon } from '@frontendmentorio/design-system-v2';

import Card from './Card';

export default function PPP() {
  const { discount, location } = useLocation();

  if (location?.isVPN) {
    return (
      <Card
        heading="Hey there, it looks like you’re using a VPN"
        icon={
          <Icon
            className="text-white text-xl"
            name="user-secret"
            style="solid"
          />
        }
      >
        We support Purchasing Power Parity, so please disable your VPN and
        refresh the page to see if you’re eligible for a discounted
        subscription.
      </Card>
    );
  }

  if (discount) {
    return (
      <Card
        heading={`Hey! It looks like you’re based in ${location?.country.name}`}
        icon={<span className="text-2xl">{location?.country.flag}</span>}
      >
        We support Purchasing Power Parity, so a{' '}
        <span className="font-bold">{discount * 100}% discount</span> will be
        applied automatically at checkout 🙂
      </Card>
    );
  }

  return null;
}
